// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`OrganizationAnalytics renders error state 1`] = `
<DocumentFragment>
  <div>
    Error fetching data.  
  </div>
</DocumentFragment>
`;

exports[`OrganizationAnalytics renders loading state 1`] = `
<DocumentFragment>
  @keyframes animation-0 {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes animation-1 {
  0% {
    stroke-dasharray: 1px,200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px,200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px,200px;
    stroke-dashoffset: -125px;
  }
}

.emotion-0 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 16px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.emotion-1 {
  display: inline-block;
  color: #4B35FF;
  -webkit-animation: animation-0 1.4s linear infinite;
  animation: animation-0 1.4s linear infinite;
}

.emotion-2 {
  display: block;
}

.emotion-3 {
  stroke: currentColor;
  stroke-dasharray: 80px,200px;
  stroke-dashoffset: 0;
  -webkit-animation: animation-1 1.4s ease-in-out infinite;
  animation: animation-1 1.4s ease-in-out infinite;
}

.emotion-4 {
  margin: 0;
  font: inherit;
}

<div
    class="MuiStack-root emotion-0"
  >
    <span
      class="MuiCircularProgress-root MuiCircularProgress-indeterminate MuiCircularProgress-colorPrimary emotion-1"
      role="progressbar"
      style="width: 40px; height: 40px;"
    >
      <svg
        class="MuiCircularProgress-svg emotion-2"
        viewBox="22 22 44 44"
      >
        <circle
          class="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate emotion-3"
          cx="44"
          cy="44"
          fill="none"
          r="20.2"
          stroke-width="3.6"
        />
      </svg>
    </span>
    <p
      class="MuiTypography-root MuiTypography-inherit emotion-4"
    >
      Loading analytics...
    </p>
  </div>
</DocumentFragment>
`;

exports[`OrganizationAnalytics renders no analytics data state 1`] = `
<DocumentFragment>
  <div>
    No analytics data available.
  </div>
</DocumentFragment>
`;

exports[`OrganizationAnalytics renders the analytics data 1`] = `
<DocumentFragment>
  .emotion-0 {
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  margin-top: -16px;
  width: calc(100% + 16px);
  margin-left: -16px;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
}

.emotion-0>.MuiGrid-item {
  padding-top: 16px;
}

.emotion-0>.MuiGrid-item {
  padding-left: 16px;
}

.emotion-1 {
  box-sizing: border-box;
  margin: 0;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.emotion-2 {
  background-color: #FCFAFD;
  color: #1C1B1F;
  -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 8px;
  box-shadow: none;
  background-image: none;
  border-radius: 24px;
  overflow: hidden;
  padding: 16px;
  text-align: center;
  color: #1C1B1FB3;
  background-color: #F1ECF4;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: auto;
}

.emotion-3 {
  padding: 16px;
}

.emotion-3:last-child {
  padding-bottom: 24px;
}

.emotion-5 {
  margin: 0;
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.emotion-6 {
  margin: 0;
}

<div>
    <div
      class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 emotion-0"
    >
      <div
        class="MuiGrid-root MuiGrid-item emotion-1"
      >
        <div
          class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-2"
        >
          <div
            class="MuiCardContent-root emotion-3"
          >
            <div
              class="MuiBox-root emotion-4"
            >
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-5"
              >
                10
              </p>
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-6"
              >
                Members
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-item emotion-1"
      >
        <div
          class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-2"
        >
          <div
            class="MuiCardContent-root emotion-3"
          >
            <div
              class="MuiBox-root emotion-4"
            >
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-5"
              >
                5
              </p>
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-6"
              >
                Active Lessons
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-item emotion-1"
      >
        <div
          class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-2"
        >
          <div
            class="MuiCardContent-root emotion-3"
          >
            <div
              class="MuiBox-root emotion-4"
            >
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-5"
              >
                3
              </p>
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-6"
              >
                Lesson Creators
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-item emotion-1"
      >
        <div
          class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-2"
        >
          <div
            class="MuiCardContent-root emotion-3"
          >
            <div
              class="MuiBox-root emotion-4"
            >
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-5"
              >
                5
              </p>
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-6"
              >
                Unique LTI Players
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-item emotion-1"
      >
        <div
          class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-2"
        >
          <div
            class="MuiCardContent-root emotion-3"
          >
            <div
              class="MuiBox-root emotion-4"
            >
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-5"
              >
                15
              </p>
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-6"
              >
                Unique Kyron Players
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-item emotion-1"
      >
        <div
          class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-2"
        >
          <div
            class="MuiCardContent-root emotion-3"
          >
            <div
              class="MuiBox-root emotion-4"
            >
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-5"
              >
                10
              </p>
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-6"
              >
                Lessons Completed
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-item emotion-1"
      >
        <div
          class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-2"
        >
          <div
            class="MuiCardContent-root emotion-3"
          >
            <div
              class="MuiBox-root emotion-4"
            >
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-5"
              >
                20
              </p>
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-6"
              >
                Lessons Attempted
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-item emotion-1"
      >
        <div
          class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root emotion-2"
        >
          <div
            class="MuiCardContent-root emotion-3"
          >
            <div
              class="MuiBox-root emotion-4"
            >
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-5"
              >
                50
              </p>
              <p
                class="MuiTypography-root MuiTypography-body1 emotion-6"
              >
                Lesson Completion %
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</DocumentFragment>
`;
